/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_How_3_TitleInputs */

const en_landing_how_3_title = /** @type {(inputs: Landing_How_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verify at every step`)
};

const id_landing_how_3_title = /** @type {(inputs: Landing_How_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifikasi tiap langkah`)
};

/**
* | output |
* | --- |
* | "Verify at every step" |
*
* @param {Landing_How_3_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const landing_how_3_title = /** @type {((inputs?: Landing_How_3_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_How_3_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_landing_how_3_title(inputs)
	return en_landing_how_3_title(inputs)
});